import { formatPartnerMoneyFromMicroUnits } from '../../../shared/lib/money.js';

function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) return '-';
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString();
}

export function buildCommissionsTableModel(dtoRows) {
  return dtoRows.map((row) => ({
    key: row.key,
    uid: row.uid,
    type: row.type,
    status: row.status,
    depth: row.depth,
    lots: row.lots || '\u2014',
    amountFormatted: formatPartnerMoneyFromMicroUnits(row.amountMicro, row.currency),
    currency: row.currency,
    partnerUid: row.partnerUid,
    clientUid: row.clientUid,
    clientName: row.clientName,
    createdAt: formatDate(row.created),
  }));
}
